// Import the functions you need from the SDKs you need
import { getAnalytics } from "firebase/analytics";

import { GoogleAuthProvider, signInWithPopup , getAuth} from 'firebase/auth';
import { initializeApp } from 'firebase/app';
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyCqwKW3UkNPuVcat7Pe48DfsqZbHGPaRU0",
  authDomain: "bookiebrawler-380718.firebaseapp.com",
  projectId: "bookiebrawler-380718",
  storageBucket: "bookiebrawler-380718.appspot.com",
  messagingSenderId: "1015240395841",
  appId: "1:1015240395841:web:a344ffbda2523e98280ac0",
  measurementId: "G-TRGR1YGZ39"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
export const auth = getAuth(app);
const analytics = getAnalytics(app);

// Exported for firebase/messaging (web push). NOTE: this config is public
// by design (it ships in the bundle); the same values are duplicated in
// public/firebase-messaging-sw.js, which cannot import this module — keep
// the two in sync if the Firebase project ever changes.
export { app };